// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__3I0Iv","label":"Completed_label__1Ul-3"};